import React from "react";


export default function withRoot<T extends object>(
  Component: React.ComponentType<T>
) {
  const WithRoot = (props: T) => {
    return (
      <Component {...props} />
    );
  };

  WithRoot.displayName = `withRoot(${Component.displayName || Component.name || "Component"})`;

  return WithRoot;
}
